var map = {
	"./cristofer-maximilian-uQDRDqpYJHI-unsplash.jpg": "8c91",
	"./laura-chouette-enQcrUMOp_U-unsplash.jpg": "d0c0",
	"./lily-banse--YHSwy6uqvk-unsplash.jpg": "0aea",
	"./patrick-dozkVhDyvhQ-unsplash.jpg": "12a4",
	"./steve-halama-T9A31lqrXnU-unsplash.jpg": "c320"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";